import controller from "servicestack/auto-query/auto-query-tag-filter.controller";
import templateUrl from "servicestack/auto-query/auto-query-tag-filter.htm";
import toggleSwitchView from "servicestack/auto-query/auto-query-tag-filter.toggle-switch.htm";

export default {
  bindings: {
    filter: "<",
    onToggle: "&",
    hideCheckboxes: "@",
    hideEmptyGroupings: "@",
    hideGroupingCounts: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.view === "toggle-switch"
      ? toggleSwitchView
      : $attrs.templateUrl || templateUrl;
  },
};
